<template>
  <NuxtLayout name="sticky">
    <template #background>
      <slot name="background" />
    </template>

    <template #header>
      <nav>
        <LcHeader
          @left-button-click="
            navigateBack({
              previousRoute: backRoute ?? previousRoute,
            })
          "
        >
          <template #headline>
            <h1 v-if="title" class="headline headline-h3-headline" v-text="title" />
            <slot v-else name="headline" />
          </template>
        </LcHeader>
      </nav>
    </template>

    <template #default>
      <div
        class="layout-overlay-content"
        :class="{ 'with-bottom-navigation': withBottomNavigation }"
      >
        <slot />
      </div>
    </template>

    <template v-if="$slots.navbar" #navbar>
      <slot name="navbar" />
    </template>

    <template #after>
      <LazyVisibleTheFooter hydrate-on-visible />
      <LazyTheBottomNavigation v-if="withBottomNavigation" />
    </template>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import type { RouteLocationRaw } from '#vue-router'

export type OverlayLayoutProps = {
  backRoute?: RouteLocationRaw
  navIcon?: 'arrow-left' | 'close'
  previousRoute?: RouteLocationRaw
  title?: string
  withBottomNavigation?: boolean
}

defineProps<OverlayLayoutProps>()

const { navigateBack } = useRouterUtils()
</script>

<style lang="scss" scoped>
.layout-overlay {
  &-content {
    &.with-bottom-navigation {
      padding-bottom: 1rem;
    }
  }
}
</style>
